<template>
  <div>
    <b-form-select class="mt-2" v-model="selectedType" :options="cardOptions">
      <template #first>
        <b-form-select-option :value="null" disabled
          >Оберіть карту</b-form-select-option
        >
      </template>
    </b-form-select>
    <b-table
      class="mt-2"
      striped
      responsive
      :fields="tableFields"
      :items="clients"
    >
    </b-table>
  </div>
</template>

<script>
export default {
  name: "ClientsWithCards",
  data: function () {
    return {
      selectedType: null,
      tableFields: [
        { key: "name", label: "Ім'я" },
        { key: "surname", label: "Призвіще" },
        { key: "phonenum", label: "Номер телефону" },
      ],
      clients: [],
      cards: [],
    };
  },
  computed: {
    cardOptions: function () {
      let options = [];
      this.cards.forEach((card) => {
        options.push({
          value: card.id,
          text: card.name,
        });
      });
      return options;
    },
  },
  watch: {
    selectedType: function (newVal) {
      this.fetchClients(newVal);
    },
  },
  async mounted() {
    await this.getCardOptions();
  },
  methods: {
    async getCardOptions() {
      let response = await this.$api.products.getCards();
      this.cards = response.data;
    },
    async fetchClients(type) {
      let response = await this.$api.clients.getByCardType(type);
      this.clients = response.data;
    },
  },
};
</script>

<style scoped></style>
